// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"484":"6407f3495d54820cc32a","596":"cdd40d62b46e1194f84e"}[chunkId] + ".js";
};